import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { WorkspaceComponent } from '../app/pages/workspace/workspace';
import { UnauthorizedPage } from './pages/system-pages/unauthorized-page/unauthorized-page';
import { PageNotFound } from './pages/system-pages/page-not-found/page-not-found';
import { Memberlogout } from './pages/system-pages/memberlogout/memberlogout';
import { LandingPage } from './pages/system-pages/landing-page/landing-page';
import { ErrorBoundaryComponent } from './pages/system-pages/error-boundary/error-boundary';
import { systemPageGuard } from '../guard/navigation-flag.guard';
import { workspaceResolver } from '../resolver/workspace.resolver';

export const routes: Routes = [
  { path: '', component: LandingPage },
  { path: 'workspace', component: WorkspaceComponent, canActivate: [MsalGuard], resolve: { workspaceData: workspaceResolver } },
  { path: 'unauthorized', component: UnauthorizedPage, canActivate: [systemPageGuard] },
  { path: 'logout', component: Memberlogout },
  { path: 'error', component: ErrorBoundaryComponent, canActivate: [systemPageGuard] },
  { path: '**', component: PageNotFound }
];